/**
 * Order Status Handler — изменение payment/delivery статусов через apiRequest.
 *
 * Модель: radio-button поведение на чекбоксах (нельзя снять отметку, смена
 * активного статуса — только клик на другой).
 */

import { apiRequest, APIError } from '../../api.js';

function enforceRadioBehavior(checkbox, groupSelector) {
    // Если пытаются снять — восстанавливаем
    if (!checkbox.checked) {
        checkbox.checked = true;
        return false;
    }
    // Снимаем отметку со всех остальных
    document.querySelectorAll(groupSelector).forEach(other => {
        if (other !== checkbox) other.checked = false;
    });
    return true;
}

async function sendStatusUpdate({ url, entityType, orderId, checkbox, groupSelector }) {
    // Disable all checkboxes in group during request
    const group = document.querySelectorAll(groupSelector);
    group.forEach(cb => { cb.disabled = true; });

    try {
        const response = await apiRequest(url, { method: 'POST' });

        if (response && response.success) {
            // Обновить текст статуса (универсальный селектор по adm_r_filter/adm_r_filter_delivery)
            const filterId = entityType === 'payment' ? '#adm_r_filter' : '#adm_r_filter_delivery';
            const filter = document.querySelector(filterId);
            const statusText = filter?.closest('.adm_req_project_status')?.querySelector('.adm_req_project_status_info_text');
            if (statusText) statusText.textContent = response.status_name;

            window.showToast('success', `${entityType === 'payment' ? 'Payment' : 'Delivery'} status updated successfully`);
        } else {
            window.showToast('error', `Failed to update ${entityType} status`);
        }
    } catch (e) {
        console.error(`Error updating ${entityType} status:`, e);
        const msg = e instanceof APIError ? e.message : `Error updating ${entityType} status`;
        window.showToast('error', msg);

        // Revert — снять отметку с текущего
        checkbox.checked = false;

        // Для payment: восстановить предыдущий статус из data-previous-status
        if (entityType === 'payment') {
            const row = document.querySelector(`[data-order-id="${orderId}"]`);
            const prevStatus = row?.dataset.previousStatus;
            if (prevStatus) {
                const prevCheckbox = document.querySelector(`.payment-status-checkbox[data-status-id="${prevStatus}"]`);
                if (prevCheckbox) prevCheckbox.checked = true;
            }
        }
    } finally {
        group.forEach(cb => { cb.disabled = false; });
    }
}

function initStatusHandlers() {
    document.addEventListener('change', e => {
        // Payment status checkbox
        if (e.target.matches('.payment-status-checkbox')) {
            if (!enforceRadioBehavior(e.target, '.payment-status-checkbox')) return;

            const statusId = e.target.dataset.statusId;
            const orderId = e.target.dataset.orderId;
            const userId = e.target.dataset.userId;

            sendStatusUpdate({
                url: `/manager/user/${userId}/order/${orderId}/pay/${statusId}`,
                entityType: 'payment',
                orderId,
                checkbox: e.target,
                groupSelector: '.payment-status-checkbox',
            });
            return;
        }

        // Delivery status checkbox
        if (e.target.matches('.delivery-status-checkbox')) {
            if (!enforceRadioBehavior(e.target, '.delivery-status-checkbox')) return;

            const statusId = e.target.dataset.statusId;
            const orderId = e.target.dataset.orderId;
            const userId = e.target.dataset.userId;

            sendStatusUpdate({
                url: `/manager/user/${userId}/order/${orderId}/delivery/${statusId}`,
                entityType: 'delivery',
                orderId,
                checkbox: e.target,
                groupSelector: '.delivery-status-checkbox',
            });
        }
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStatusHandlers);
} else {
    initStatusHandlers();
}
